import { Paragraph } from '@tmov/design-system';
import PropTypes from 'prop-types';
import React from 'react';

import notFound from '../../assets/images/not-found.png';
import { Container } from './styles';

function NoDataContainer({ img, title, description }) {
  return (
    <Container data-testid="no-data-container">
      <img src={img} alt="Not found" />
      <Paragraph variant="p1" fontWeight="semibold">
        {title}
      </Paragraph>
      <Paragraph variant="p2">{description}</Paragraph>
    </Container>
  );
}

NoDataContainer.propTypes = {
  img: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

NoDataContainer.defaultProps = {
  img: notFound,
  title: 'Ops, não encontramos nenhum resultado para sua pesquisa',
  description: 'Talvez seja necessário ajustar os filtros.',
};

export default NoDataContainer;
